/**
 * @generated SignedSource<<c03fbc0e83d90c2fee8fcb24185111ce>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddAPIKeyInput = {
  description?: string;
  expiresAt?: string | null | undefined;
};
export type AddAPIKeyMutation$variables = {
  connections: ReadonlyArray<string>;
  input: AddAPIKeyInput;
};
export type AddAPIKeyMutation$data = {
  readonly addAPIKey: {
    readonly key: {
      readonly description: string;
      readonly expiresAt: string | null | undefined;
      readonly id: string;
      readonly identity: string;
      readonly lastUsed: string | null | undefined;
      readonly revokedAt: string | null | undefined;
    } | null | undefined;
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly secret: string | null | undefined;
  };
};
export type AddAPIKeyMutation = {
  response: AddAPIKeyMutation$data;
  variables: AddAPIKeyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "APIKey",
  "kind": "LinkedField",
  "name": "key",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiresAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastUsed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "revokedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "secret",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddAPIKeyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "AddAPIKeyPayload",
        "kind": "LinkedField",
        "name": "addAPIKey",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          (v5/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "AddAPIKeyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "AddAPIKeyPayload",
        "kind": "LinkedField",
        "name": "addAPIKey",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "key",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "APIKeyEdge"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          (v5/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eab2702dfb1ef02f3ada4c05e2185b36",
    "id": null,
    "metadata": {},
    "name": "AddAPIKeyMutation",
    "operationKind": "mutation",
    "text": "mutation AddAPIKeyMutation(\n  $input: AddAPIKeyInput!\n) {\n  addAPIKey(input: $input) {\n    key {\n      description\n      expiresAt\n      id\n      identity\n      lastUsed\n      revokedAt\n    }\n    problems {\n      __typename\n      message\n    }\n    secret\n  }\n}\n"
  }
};
})();

(node as any).hash = "e106549790a8c42f34b31f23cac68297";

export default node;
